import type { Environment } from './environment.model';

// No secrets here: this file ships to the browser.
export const environment = {
  production: true,
  appName: 'ME Operations (Dev)',

  apiUrl: 'https://operations-dev-api-hsbpevh3ewbyg0eq.eastus-01.azurewebsites.net',
  legacyPortalUrl: 'https://dev-sales.azurewebsites.net',

  authorizeNetJsUrl: 'https://jstest.authorize.net/v1/Accept.js',
  authorizeNetJsClientKey: 'REPLACE-ME',
  authorizeNetAppLoginId: 'REPLACE-ME',

  // Pages opened here; Order Entry is a blank placeholder until the real page ships (LG-06). Others link to # (EP-33).
  flippedPages: ['order-entry', 'edit-profile'],
} satisfies Environment;
